import * as React from "react";
import { cn } from "../../lib/utils";

interface StatProps extends React.ComponentProps<"div"> {
  label: React.ReactNode;
  value: React.ReactNode;
  hint?: React.ReactNode;
  icon?: React.ReactNode;
}

/** Metric tile: label on top, big tabular number, optional hint. */
function Stat({ label, value, hint, icon, className, ...props }: StatProps) {
  return (
    <div
      data-slot="stat"
      className={cn("surface p-5 flex items-start justify-between gap-4", className)}
      {...props}
    >
      <div className="min-w-0">
        <p className="text-[13px] font-medium text-text-tertiary">{label}</p>
        <p className="mt-1.5 font-display text-2xl font-semibold tracking-tight tabular truncate">
          {value}
        </p>
        {hint && <p className="mt-1 text-[13px] text-text-secondary">{hint}</p>}
      </div>
      {icon && (
        <div className="flex size-9 shrink-0 items-center justify-center rounded-lg bg-primary-soft text-primary [&>svg]:size-4">
          {icon}
        </div>
      )}
    </div>
  );
}

export { Stat };
